import * as THREE from 'three';
import { WEBGL } from 'three/examples/jsm/WebGL';
import { leinWand, kamera, renderer } from './index';

export default class Helfer {
	// https://threejs.org/docs/#manual/en/introduction/WebGL-compatibility-check
	static kompatibilitätsCheck(): void {
		if (!WEBGL.isWebGLAvailable()) {
			const warnung = WEBGL.getWebGLErrorMessage();
			document.body.appendChild(warnung);
		}
	}

	static synchronisiereCanvasGrößen(canvasBreite: number, canvasHöhe: number) {
		// Wenn die Größe des Bildschirms sich ändert gucken ob die Größe des Canvas Element sich
		// mit der inneren Größe des Canvas übereinstimmt, wenn nicht dann setze die innere Größe
		// des Canvas neu
			canvasBreite = leinWand.clientWidth;
			canvasHöhe = leinWand.clientHeight;
			if (canvasBreite !== leinWand.width || canvasHöhe !== leinWand.height) {
				renderer.setSize(canvasBreite, canvasHöhe, false);
				kamera.aspect = canvasBreite / canvasHöhe;
				kamera.updateProjectionMatrix();
			}
	}

	static gradZuBogenMaß(grad: number) {
		// https://www.rapidtables.com/convert/number/degrees-to-radians.html
		return (grad * Math.PI) / 180;
	}

	static bogenMaßZuGrad(bogenMaß: number) {
		return (bogenMaß / Math.PI) * 180;
	}

	// Ich weiss nicht wie ich das erklären soll... aber ich kann nur sagen, dasss
	// Quaternions hier nicht funktionieren würden, da der ganze Körper sich dann rotieren würde
	// ohne, dass der Spieler es bemerkt
	static rotiereVektorNachOben(vektor: THREE.Vector3, vorherigerVektor: THREE.Vector3) {
		if(Math.abs(vektor.z) === 1 || Math.abs(vektor.x) === 1) {
			kamera.up.copy(vektor.clone().applyAxisAngle(new THREE.Vector3(vektor.x, 0, vektor.z), this.gradZuBogenMaß(90)));
			kamera.up.negate()
			return vektor.set(0, 1, 0);
		}

		if(Math.abs(vektor.y) === 1) {
			kamera.up.set(0, 1, 0);
			if(vektor.y === -1) {
				vektor.copy(vorherigerVektor);
			}
			if(vektor.y === 1) {
				vektor.copy(vorherigerVektor.clone().negate());
			}
		}
		
	}

	static rotiereVektorNachRechts(vektor: THREE.Vector3, vorherigerVektor: THREE.Vector3) {

		if(Math.abs(vektor.x) === 1) {
			return vektor.set(0, 0, vektor.x);
		} 
		if(Math.abs(vektor.z) === 1) {
			return vektor.set(-(vektor.z), 0, 0)
		}

		if(Math.abs(vektor.y) === 1) {
			kamera.up.set(0, 1, 0);
			if(Math.abs(vorherigerVektor.z) === 1) {
				return vektor.set(-(vorherigerVektor.z), 0, 0);
			}

			if(Math.abs(vorherigerVektor.x) === 1) {
				return vektor.set(0, 0, vorherigerVektor.x);
			}
		}
	}
	
}
